export default __webpack_public_path__ + "static/media/deposit-ico.5abe5c40.svg";